<template>
    <div>
        <div class="az-form-content">
            <painel-documento-solicitado-visualizacao v-model="compraDireta.documentosSolicitados"
                                                      :documentos="documentos"/>

            <painel-linha-fornecimento-visualizacao v-model="compraDireta.linhasFornecimento"/>

            <painel-convidado-visualizacao v-model="compraDireta.convidados"/>
        </div>

        <div class="az-actions-form ajuste-acoes">
            <botao-voltar @voltar="tratarEventoVoltar"/>
            <botao-avancar :disabled="ehCompraEmElaboracao" @avancar="tratarEventoAvancar"/>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import PainelDocumentoSolicitadoVisualizacao from './painel-documento-solicitado/PainelDocumentoSolicitadoVisualizacao'
import PainelLinhaFornecimentoVisualizacao from './painel-linha-fornecimento/PainelLinhaFornecimentoVisualizacao'
import PainelConvidadoVisualizacao from './painel-convidado/PainelConvidadoVisualizacao'
import {actionTypes} from '@/core/constants'

export default {
    name: 'DocumentosVisualizacao',
    components: {
        PainelDocumentoSolicitadoVisualizacao,
        PainelLinhaFornecimentoVisualizacao,
        PainelConvidadoVisualizacao
    },
    data() {
        return {
            compraDiretaId: null,
            documentos: []
        }
    },
    computed: {
        ...mapState(['compraDireta', 'resumoCompraDireta']),
        ehCompraEmElaboracao(){
            return this.resumoCompraDireta.situacao === 'EM_ELABORACAO'
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDocumentosDaProposta()
            await this.buscarDocumentosSolicitados()
            await this.buscarLinhasFornecimentoDaCompraDireta()
            await this.buscarConvidadosDaCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDocumentosSolicitados() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_SOLICITADOS, this.compraDiretaId)
        },
        async buscarDocumentosDaProposta() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA)
            this.documentos = this.$store.state.documentosProposta
        },
        async buscarLinhasFornecimentoDaCompraDireta() {
            await this.$store.dispatch(actionTypes.BUSCAR_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        async buscarConvidadosDaCompraDireta() {
            await this.$store.dispatch(actionTypes.BUSCAR_CONVIDADOS_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        tratarEventoVoltar() {
            this.$router.push({name: 'ItensLotesVisualizacao', params: this.compraDiretaId})
        },
        tratarEventoAvancar() {
            if(this.ehCompraEmElaboracao) return
            this.$router.push({name: 'AcompanhamentoVisualizacao', params: this.compraDiretaId})
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        }
    }
}
</script>

<style scoped lang="stylus">

</style>